<template>
  <div id="eventDialog_main">
    <el-dialog
      custom-class="eventDialog"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="75%"
    >
      <div
        slot="title"
        class="dialogTitle"
      >
        <span class="title">{{ dialogType+'活動' }}</span>
        <el-button
          v-if="dialogType === '編輯'"
          class="delEvent"
          round
          @click="delEvent"
        >
          刪除此活動
        </el-button>
      </div>
      <el-form
        label-position="top"
        :model="event"
      >
        <div class="left">
          <el-form-item
            label="活動"
            class="required"
          >
            <el-input
              v-model="event.Title"
              placeholder="例如：清洗水塔"
              :class="validate.Title ? '':'borderRed'"
              maxlength="20"
              clearable
            />
            <div class="colorDiv">
              <div class="colorTitle">
                標籤顏色：
              </div>
              <el-radio-group
                v-for="(item,index) in presetColorOption"
                :key="index"
                v-model="event.ColorType"
                class="color-select"
              >
                <el-radio
                  :label="index"
                  :style="'background-color:'+item"
                >
                  <i
                    v-if="event.ColorType === index"
                    class="icon-check-mark"
                    aria-hidden="true"
                  />
                  <span v-else />
                </el-radio>
              </el-radio-group>
              <div class="colorTitle colorTitle2">
                自訂顏色
              </div>
              <div class="color-select customColor">
                <div
                  class="showCustomColor"
                  :style="'background-color:'+event.Color"
                >
                  <i
                    v-if="event.ColorType === 5"
                    class="icon-check-mark"
                    aria-hidden="true"
                  />
                </div>
                <el-radio
                  v-model="event.ColorType"
                  :label="5"
                >
                  <el-color-picker
                    v-model="event.Color"
                    popper-class="calendarColorSelect"
                    color-format="hex"
                    @active-change="changeColor"
                  />
                </el-radio>
              </div>
            </div>
            <div class="colorTitle">
              常用顏色：
            </div>
            <el-radio-group
              v-for="(item,index) in recentColorOption"
              :key="index"
              v-model="recentColor"
              class="color-select"
              @change="changeRecentColorOption"
            >
              <el-radio
                :label="index"
                :style="'background-color:'+item"
              >
                <span />
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="可瀏覽對象"
            class="required"
          >
            <el-select
              v-model="event.BrowseType"
              placeholder="請選擇"
              :class="validate.BrowseType ? '':'borderRed'"
            >
              <el-option
                v-for="(item,index) in browseTypeOption"
                :key="index"
                :label="item"
                :value="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="時間"
            class="required"
          >
            <el-date-picker
              v-model="date"
              :class="validate.Date ? '':'borderRed'"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="開始日期"
              end-placeholder="結束日期"
            />
            <div class="time-select">
              <el-time-select
                v-model="event.StartTime"
                align="center"
                :disabled="event.IsAllDay"
                :picker-options="{start: '00:00', end: '23:30', step: '00:30', maxTime: event.EndTime}"
                :class="validate.StartTime ? '':'borderRed'"
                placeholder="開始時間"
                class="el-time-select"
              />
              <span class="time-select-span">到</span>
              <el-time-select
                v-model="event.EndTime"
                :disabled="event.IsAllDay"
                :picker-options="{start: '00:00', end: '23:30', step: '00:30', minTime: event.StartTime}"
                :class="validate.EndTime ? '':'borderRed'"
                placeholder="結束時間"
                class="el-time-select"
              />
              <el-checkbox
                v-model="event.IsAllDay"
                @change="changeIsAllDay"
              >
                全天時段
              </el-checkbox>
            </div>
          </el-form-item>
        </div>
        <div class="right">
          <el-form-item label="地點">
            <el-input
              v-model="event.Location"
              maxlength="70"
              placeholder="例如：大樓頂樓"
            />
          </el-form-item>
          <el-form-item label="描述">
            <el-input
              v-model="event.Description"
              type="textarea"
              placeholder="例如：例行性水塔清洗"
              maxlength="250"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="附加檔案">
            <span class="fileTip">最多可選擇 3 個檔案或圖片</span>
            <UploadMixedFiles
              class="fileGroup"
              :filearray="files"
              :quantity="3"
              @on-fileArray-change="changeFiles"
            />
          </el-form-item>
        </div>
      </el-form>
      <div class="saveEvent">
        <el-button
          v-if="dialogType === '編輯'"
          type="primary"
          round
          @click="saveEvent()"
        >
          儲存活動
        </el-button>
        <el-button
          v-else
          type="primary"
          round
          @click="saveEvent()"
        >
          建立活動
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import UploadMixedFiles from '../../../components/UploadMixedFiles'
import { housekeeperAPI } from '@/api/HousekeeperAPI.js'

export default {
  components: {
    UploadMixedFiles
  },
  data () {
    return {
      calendarValue: '',
      presetColorOption: ['#29b6d8', '#51bf87', '#777777', '#f8ac59', '#ec4758'], // 預設顏色
      recentColorOption: [], // 常用顏色
      browseTypeOption: ['全社區', '委員會', '樓管'], // 可瀏覽對象
      event: {
        Id: '',
        Title: '',
        ColorType: 0,
        Color: '#666',
        BrowseType: 0,
        IsAllDay: true,
        StartTime: '',
        EndTime: '',
        Location: '',
        Description: '',
        Files: []
      },
      validate: { // 通過true,未通過false
        Title: true,
        BrowseType: true,
        Date: true,
        StartTime: true,
        EndTime: true
      },
      files: [],
      recentColor: '',
      date: [],
      dialogType: '', // 新增或編輯
      dialogVisible: false,
      canClickButton: true
    }
  },
  methods: {
    openDialog (dialogType, data, calendarValue) {
      console.log(data)
      this.dialogType = dialogType
      this.calendarValue = new Date(calendarValue)
      this.getRecentColor()
      if (dialogType === '新增') {
        this.event = {
          Id: '',
          Title: '',
          ColorType: 0,
          Color: '#666',
          BrowseType: 0,
          IsAllDay: true,
          StartTime: '',
          EndTime: '',
          Location: '',
          Description: '',
          Files: []
        }
        this.files = []
        this.date = [
          data,
          data
        ]
        this.event.StartTime = this.$newFormatDate(data.StartTime).substring(0, 10)
      } else if (dialogType === '編輯') {
        const copyData = JSON.parse(JSON.stringify(data))
        this.event.Id = copyData.Id
        this.event.Title = copyData.Title
        this.event.ColorType = copyData.ColorType
        this.event.Color = copyData.Color === '' ? '#666' : copyData.Color
        this.event.BrowseType = copyData.BrowseType
        this.event.IsAllDay = copyData.CalendarTime.IsAllDay
        this.event.StartTime = copyData.CalendarTime.IsAllDay ? '' : copyData.CalendarTime.StartTime
        this.event.EndTime = copyData.CalendarTime.IsAllDay ? '' : copyData.CalendarTime.EndTime
        this.event.Location = copyData.Location
        this.event.Description = copyData.Description
        this.date = [
          copyData.CalendarTime.continuousEventStartDate,
          copyData.CalendarTime.EndDate
        ]
        copyData.Files.forEach((item, index) => {
          item.fileName = '附檔' + (index + 1) + '.' + item.FileUri.split('?')[0].split('.').pop().toLowerCase() + '(' + item.FileSize + 'KB)'
        })
        this.files = copyData.Files
      }
      this.validate = {
        Title: true,
        BrowseType: true,
        Date: true,
        StartTime: true,
        EndTime: true
      }
      this.dialogVisible = true
    },
    // 取得活動常用顏色
    getRecentColor () {
      apiCalendar.GetRecentColor().then((res) => {
        if (res.status === 200) {
          this.recentColorOption = res.data.Data
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // 判斷送出活動規則
    saveEvent () {
      console.log(this.canClickButton)
      if (this.canClickButton) {
        this.canClickButton = false
        this.validate.Title = this.event.Title !== ''
        this.validate.BrowseType = !!(this.event.BrowseType === 0 || this.event.BrowseType === 1 || this.event.BrowseType === 2)
        this.validate.Date = this.date !== null
        if (!this.event.IsAllDay) { // 未勾選 全天時段
          this.validate.StartTime = this.event.StartTime !== ''
          this.validate.EndTime = this.event.EndTime !== ''
        } else {
          this.validate.StartTime = true
          this.validate.EndTime = true
        }
        let canSubmit = true
        for (const item in this.validate) {
          if (this.validate[item] === false) { canSubmit = false }
        }
        if (canSubmit === false) {
          this.canClickButton = true
          return
        }
        if (this.files.length > 0) {
          this.filesToUrl()
        } else {
          if (this.dialogType === '新增') { this.creatEvent() } else if (this.dialogType === '編輯') { this.editEvent() }
        }
        setTimeout(() => {
          this.canClickButton = true
        }, 1000)
      }
    },
    async filesToUrl () {
      this.fullScreenLoading(true)
      this.event.Files = []
      const loginUserInfo = JSON.parse(localStorage.getItem('loginUserInfo'))
      const bucketName = '/smartdaily-file/'
      const gsRootPath = 'gs:/' + bucketName
      let env = 'Production'
      if (process.env.VUE_APP_ENV === 'staging') {
        env = 'Staging'
      } else if (process.env.VUE_APP_ENV === 'dev') {
        env = 'Development'
      }
      const date = this.date[0].split('-')
      const keyRootPath = `CommunityFile/${env}/${loginUserInfo.ComId}/Calendar/${date[0]}/${date[1]}/`

      // 取得簽章資訊（Fields、SignedUrl），整批檔案共用，不需在迴圈中重複呼叫
      const signedData = await this.getSignedUrl()
      if (!signedData) {
        this.fullScreenLoading(false)
        return
      }

      for (let i = 0; i < this.files.length; i++) {
        if (this.files[i].file) {
          const uploadFormData = new FormData()
          const key = keyRootPath + (new Date().getTime()) + '.' + (this.files[i].file.name ? this.files[i].file.name.split('.').pop() : '')
          uploadFormData.append('key', key)
          uploadFormData.append('file', this.files[i].file, Math.round(new Date().getTime() / 1000) + '.' + this.files[i].file.name.split('.')[this.files[i].file.name.split('.').length - 1].toLowerCase())
          const success = await this.postUploadEventFile(uploadFormData, signedData)
          if (!success) {
            this.fullScreenLoading(false)
            return
          }
          this.event.Files.push({
            f: gsRootPath + key,
            s: (this.files[i].file.size / 1024).toFixed(1)
          })
        } else {
          const urlWithoutQuery = this.files[i].FileUri.split('?')[0]
          const isSmartDailyFile = urlWithoutQuery.includes(bucketName)
          const f = isSmartDailyFile ? (gsRootPath + urlWithoutQuery.split(bucketName)[1]) : urlWithoutQuery.split('/').pop()
          this.event.Files.push({
            f,
            s: this.files[i].FileSize
          })
        }
      }
      if (this.dialogType === '新增') { this.creatEvent() } else if (this.dialogType === '編輯') { this.editEvent() }
    },
    async getSignedUrl () {
      try {
        const res = await housekeeperAPI.getCommunityCalendarSignedUrl()
        return res.data.Data
      } catch (err) {
        this.$message({
          message: '上傳過程發生異常，請重新再[送出]一次',
          type: 'warning'
        })
        return null
      }
    },
    async postUploadEventFile (uploadFormData, signedData) {
      try {
        const fields = signedData.Fields

        Object.entries(fields).forEach(([k, v]) => {
          uploadFormData.append(k, v)
        })

        // 一定要按照順序放
        // key 放file前面
        const keyValue = uploadFormData.get('key')
        uploadFormData.delete('key')
        uploadFormData.append('key', keyValue)

        // file 最後
        const fileValue = uploadFormData.get('file')
        uploadFormData.delete('file')
        uploadFormData.append('file', fileValue)

        await axios(signedData.SignedUrl, {
          method: 'POST',
          data: uploadFormData
        })

        return true
      } catch (err) {
        this.$message({
          message: '上傳過程發生異常，請重新再[送出]一次',
          type: 'warning'
        })
        return false
      }
    },
    // 建立活動
    creatEvent () {
      let newFormatStartTime = ''
      let newFormatEndTime = ''
      if (this.event.IsAllDay) {
        newFormatStartTime = '00:00:00'
        newFormatEndTime = '23:59:59'
      } else {
        newFormatStartTime = this.event.StartTime + ':00'
        newFormatEndTime = this.event.EndTime + ':00'
      }
      const requestData = {
        StartTime: this.date[0] + ' ' + newFormatStartTime,
        EndTime: this.date[1] + ' ' + newFormatEndTime,
        Title: this.event.Title,
        Location: this.event.Location,
        Description: this.event.Description,
        Files: JSON.stringify(this.event.Files),
        BrowseType: this.event.BrowseType,
        ColorType: parseInt(this.event.ColorType),
        Color: this.event.Color
      }
      apiCalendar.PostCreateEvent(
        requestData
      ).then((res) => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: '建立活動成功'
          })
        }
        this.fullScreenLoading(false)
        this.calendarInit()
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        this.$message({
          type: 'warning',
          message: err?.response?.data?.ErrorMessage?.Description || '請稍後再試'
        })
        this.fullScreenLoading(false)
      })
    },
    // 編輯活動
    editEvent () {
      let newFormatStartTime = ''
      let newFormatEndTime = ''
      if (this.event.IsAllDay) {
        newFormatStartTime = '00:00:00'
        newFormatEndTime = '23:59:59'
      } else {
        newFormatStartTime = this.event.StartTime + ':00'
        newFormatEndTime = this.event.EndTime + ':00'
      }
      const requestData = {
        Id: this.event.Id,
        StartTime: this.date[0] + ' ' + newFormatStartTime,
        EndTime: this.date[1] + ' ' + newFormatEndTime,
        Title: this.event.Title,
        Location: this.event.Location,
        Description: this.event.Description,
        Files: JSON.stringify(this.event.Files),
        BrowseType: this.event.BrowseType,
        ColorType: parseInt(this.event.ColorType),
        Color: this.event.Color
      }
      apiCalendar.PatchUpdateEvent(
        requestData
      ).then((res) => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: '編輯活動成功'
          })
        }
        this.fullScreenLoading(false)
        this.calendarInit()
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        this.$message({
          type: 'warning',
          message: err?.response?.data?.ErrorMessage?.Description || '請稍後再試'
        })
        this.fullScreenLoading(false)
      })
    },
    // 刪除活動
    delEvent () {
      if (this.canClickButton) {
        this.canClickButton = false
        this.$confirm('確認刪除活動？', '警告', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          this.$emit('deleteEvent', this.event.Id)
          this.dialogVisible = false
        }).catch(() => {})
        setTimeout(() => {
          this.canClickButton = true
        }, 2000)
      }
    },
    changeIsAllDay () {
      if (this.event.IsAllDay) {
        this.validate.StartTime = true
        this.validate.EndTime = true
      }
    },
    // 時間欄位輸入錯誤
    alertTime () {
      this.$message({
        type: 'warning',
        message: '開始時間需小於結束時間'
      })
      this.fullScreenLoading(false)
      this.validate.StartTime = false
      this.validate.EndTime = false
    },
    calendarInit () {
      this.$emit('getAnnualEventList', this.calendarValue.getFullYear())
      this.dialogVisible = false
    },
    changeRecentColorOption () {
      this.event.ColorType = 5
      this.event.Color = this.recentColorOption[this.recentColor]
    },
    changeFiles (val) {
      this.event.Files = val
    },
    // 顏色選擇器回調
    changeColor (color) {
      const reg = /[0-9]\d+/g
      const getArr = color.match(reg)
      const hex = '#' + ((getArr[0] << 16) | (getArr[1] << 8) | getArr[2]).toString(16)
      this.event.Color = hex
    },
    // 全屏loading畫面
    fullScreenLoading (display) {
      const loadingWrap = this.$loading({
        lock: true,
        text: '資料上傳中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (!display) { loadingWrap.close() }
    }
  }
}
</script>
<style lang="sass" scoped>
#eventDialog_main
  ::v-deep .eventDialog
    +basicDialog
    text-align: left
    min-width: 1080px
    max-width: 1300px
    .dialogTitle
      position: relative
      .title
        color: $mainFontColor
        font-size: map-get($fontSize,large)
        font-weight: bold
        line-height: 32px
      .delEvent
        position: absolute
        right: 40px
        top: -10px
    .el-dialog__body
      .el-form
        .el-form-item__label
          padding-bottom: 5px
        .required
          position: relative
          .el-form-item__label
            &::before
              position: absolute
              top: 0
              left: -10px
              content: "*"
              font-size: 18px
              color: $dangerColorHover
        .el-form-item__content
          .time-select
            margin-top: 10px
            .el-time-select
              width: 160px
            .time-select-span
              margin: 0px 8px
            // .el-input__inner
            //   text-align: center
            .el-checkbox
              margin-left: 10px
          .colorDiv
            margin-top: 5px
          .colorTitle
            line-height: 20px
            display: inline-block
          .colorTitle2
            margin-left: 10px
          .color-select
            display: inline-block
            padding-left: 5px
            .el-radio
              position: relative
              .el-radio__inner
                display: none
              .el-radio__label
                position: absolute
                top: 3px
                left: -7px
            label
              padding: 5px
              width: 10px
              height: 10px
            .icon-check-mark
              font-size: 14px
              color: $white
          .customColor
            position: relative
            .showCustomColor
              position: absolute
              top: 6px
              width: 20px
              height: 20px
              .icon-check-mark
                position: absolute
                left: 3px
                top: 3px
            .el-color-picker
              left: -3px
              .el-color-picker__trigger
                padding: 0
                border: 0
                width: 20px
                height: 20px
              .el-color-picker__color-inner
                opacity: 0.0
              .el-color-picker__color
                border: 0
              .el-color-picker__empty,.el-icon-arrow-down
                display: none
          .fileTip
            color: $subFontColor
            font-size: 14px
            position: absolute
            top: -10px
          .fileGroup
            margin-top: 26px
        .left
          width: 48.7%
          border-right: $borderDark1 1px solid
          padding-right: 10px
        .right
          width: 48%
          padding-left: 20px
    .saveEvent
      margin-top: 20px
      text-align: center
      border-top: $borderDark1 1px solid
      padding-top: 20px
    .borderRed
      .el-input__inner
        border: $dangerColorHover 1px solid
    .el-input__inner.borderRed
      border: $dangerColorHover 1px solid
</style>
<style lang="sass">
.calendarColorSelect
  .el-button.el-color-dropdown__link-btn
    display: none
</style>
